import React, { useEffect, useState } from 'react';

import { Skeleton, Stack, Text } from '@mantine/core';
import ReadonlyWorkoutNotesRTE from 'components/workout-program/ReadonlyWorkoutNotesRTE';
import WorkoutProgramEmptyState from 'components/workout-program/WorkoutProgramEmptyState';
import { useAuth } from 'context/auth-context';
import usePrograms from 'hooks/program/usePrograms';
import { Program } from 'types';

import { ViewWorkoutButton } from './ViewWorkoutButton';

const WorkoutProgramSection = ({
  kiloClassTypeId,
  startDate,
}: {
  kiloClassTypeId: string;
  startDate: string;
}): JSX.Element => {
  const { session } = useAuth();

  const [program, setProgram] = useState<Program | null>(null);

  const {
    data: programs,
    isLoading: programIsLoading,
    isError: programIsError,
    isSuccess: programIsSuccess,
  } = usePrograms({
    kilo_class_type: kiloClassTypeId,
    date: startDate,
  });

  useEffect(() => {
    if (programIsSuccess && programs) {
      const programList = programs.pages.map(page => page.data.results.map(pg => pg)).flat();
      setProgram(programList.length > 0 ? programList[0] : null);
    }
  }, [programIsSuccess, programs]);

  return (
    <>
      <Stack spacing='xs'>
        <Text color='dimmed' fs='italic'>
          Workout Program
        </Text>
        {programIsLoading && <Skeleton h={72} />}
        {programIsSuccess && (
          <>
            {!!program?.workoutNotes && <ReadonlyWorkoutNotesRTE workoutNotes={program.workoutNotes} />}
            {!program?.workoutNotes && <WorkoutProgramEmptyState isError={programIsError} />}
          </>
        )}
      </Stack>
      {!programIsLoading && !!session?.athlete?.activeOnWodup && <ViewWorkoutButton />}
    </>
  );
};

export default WorkoutProgramSection;
